export default "{\n    \"show\": \"Mostrar\",\n    \"hide\": \"Ocultar\"\n}\n"